export const AUTH_TOKEN_KEY = 'authToken'
export const AUTH_TOKEN_EXPIRY_KEY = 'authTokenExpiry'
export const AUTH_REFRESH_TOKEN_KEY = 'authRefreshToken'
export const AUTH_REFRESH_TOKEN_EXPIRY_KEY = 'authRefreshTokenExpiry'
export const AUTH_RETURN_URL_KEY = 'authReturnUrl'

// Token refresh configuration
// Refresh access token 5 minutes before expiry
export const TOKEN_REFRESH_BUFFER_MS = 5 * 60 * 1000
// Check token expiry every minute
export const TOKEN_REFRESH_CHECK_INTERVAL_MS = 60 * 1000

// Refresh token retry configuration
export const REFRESH_RETRY_MAX_ATTEMPTS = 4
export const REFRESH_RETRY_BASE_DELAY_MS = 1000
export const REFRESH_RETRY_MAX_DELAY_MS = 30000
